<template>
  <div id="app">
    <div class="header-top">
        <div class="logo">
          <img src="/img/plogo.png" alt="" />
        </div>
        <div class="icon">
          <van-dropdown-menu>
          <van-dropdown-item title="历年数据"  @click.native="handleYear" v-model="zyear" :options="actions" />
        </van-dropdown-menu>
        </div>
      </div>
    <div class="data-table">
      <div class="t_l">
        <table width="100%" class="compare_cont" border="1px" cellspacing="0px" style="border-collapse:collapse" align="center" bordercolor="#E5E5E5">
          <tbody>
            <tr style="border-bottom:1px solid #ccc;" :style="{ height: height23}">
              <div class="highLight" @click="handleHighLigth"><van-checkbox v-model="checked" shape="square">高亮显示不同</van-checkbox></div>
              <div class="samehide" @click="handleSamehide"><van-checkbox v-model="checked1" shape="square">隐藏相同参数</van-checkbox></div>
            </tr>
          </tbody>
        </table>
        <div class="t_l_freeze">
          <table class="t_l_freeze222" width="100%" border="1px" cellspacing="0px" style="border-collapse:collapse" align="center" bordercolor="#E5E5E5">
            <tr v-if="extAreaShow" :style="{ height: height1}">
              <td>地区</td>
            </tr>
             <tr v-if="organsShow" :style="{ height: height2}">
              <td>招录机关</td>
            </tr>
             <tr v-if="unitsShow" :style="{ height: height3}">
              <td>用人单位</td>
            </tr>
             <tr v-if="positionNameShow" :style="{ height: height4}">
              <td>职位名称</td>
            </tr>
             <tr v-if="positionCodeShow" :style="{ height: height5}">
              <td>职位代码</td>
            </tr>
             <tr v-if="positionDescShow" :style="{ height: height6}">
              <td>职位简介</td>
            </tr>
             <tr v-if="numbers" :style="{ height: height7}">
              <td>招录人数</td>
            </tr>
             <tr v-if="target" :style="{ height: height8}">
              <td>招考对象</td>
            </tr>
             <tr v-if="underGraduateShow" :style="{ height: height9}">
              <td>专业（本 科）</td>
            </tr>
             <tr v-if="graduate" :style="{ height: height10}">
              <td>专业（研究生）</td>
            </tr>
             <tr v-if="education" :style="{ height: height11}">
              <td>学历要求</td>
            </tr>
             <tr v-if="degree" :style="{ height: height12}">
              <td>学位要求</td>
            </tr> 
            <tr v-if="political" :style="{ height: height13}">
              <td>政治面貌</td>
            </tr>
             <tr v-if="specialtyExam" :style="{ height: height14}">
              <td>专业类别</td>
            </tr>
              <tr v-if="others" :style="{ height: height15}">
              <td>其他条件</td>
            </tr>
              <tr v-if="remarks" :style="{ height: height16}">
              <td>备注</td>
            </tr>
              <tr v-if="positionType" :style="{ height: height17}">
              <td>考试类别</td>
            </tr>
              <tr v-if="extSignUpCount" :style="{ height: height18}">
              <td>报考人数</td>
            </tr>
              <tr v-if="competition" :style="{ height: height19}">
              <td>竞争比</td>
            </tr>
              <tr v-if="extMinPaperScore" :style="{ height: height20}">
              <td>进面分数线</td>
            </tr>
              <tr v-if="extMaxPaperScore" :style="{ height: height21}">
              <td>最高分数线</td>
            </tr>
              <tr v-if="extInterviewCount" :style="{ height: height22}">
              <td>面试人数</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="t_r">
        <div class="t_r_t none">
          <table width="100%" class="compare_cont" border="1px" cellspacing="0px" style="border-collapse:collapse" align="center" bordercolor="#E5E5E5">
            <tbody>
              <tr style="border-bottom:1px solid #ccc;" ref="title">
               <th v-for="item in tableData" :key="item.id">
                <div class="compare_rth" style="width:7.65625rem">{{ item.positionNameCode }} <van-icon color="#FF3229" size="1rem" name="close" @click="handleDelete(item)" /></div>
               </th>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="t_r_content" id="testIscroll">
          <table id="testIscroll2" width="100%" class="compare_cont" border="1px" cellspacing="0px" style="border-collapse:collapse" align="center" bordercolor="#E5E5E5">
            <tbody>
              <tr v-if="extAreaShow" ref="compare1">
                <td v-for="item in tableData" :key="item.id" align="center">
                  <div class="compare_sznr"   :class="{ active:current1 == 1}">{{ item.extArea }}</div>
                </td>
          </tr>
          <tr v-if="organsShow" ref="compare2">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current2 == 1}">{{ item.organs }}</div>
            </td>
          </tr>
          <tr v-if="unitsShow" ref="compare3">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current3 == 1}">{{ item.units }}</div>
            </td>
          </tr>
          <tr v-if="positionNameShow" ref="compare4">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current4 == 1}">{{ item.positionName }}</div>
            </td>
          </tr>

          <tr v-if="positionCodeShow" ref="compare5">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current5 == 1}">{{ item.positionCode }}</div>
            </td>
          </tr>
          <tr v-if="positionDescShow" ref="compare6">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current6 == 1}">{{ item.positionDesc }}</div>
            </td>
          </tr>
          <tr v-if="numbers" ref="compare7">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current8 == 1}">{{ item.numbers }}</div>
            </td>
          </tr>
          <tr v-if="target" ref="compare8">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current9 == 1}">{{ item.target }}</div>
            </td>
          </tr>
          <tr v-if="underGraduateShow" ref="compare9">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current7 == 1}">{{ item.underGraduate }}</div>
            </td>
          </tr>
          <tr v-if="graduate" ref="compare10">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current10 == 1}">{{ item.graduate }}</div>
            </td>
          </tr>
          <tr v-if="education" ref="compare11">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current11 == 1}">{{ item.education }}</div>
            </td>
          </tr>
          <tr v-if="degree" ref="compare12">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current12 == 1}">{{ item.degree }}</div>
            </td>
          </tr>
          <tr v-if="political" ref="compare13">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current13 == 1}">{{ item.political }}</div>
            </td>
          </tr>
          <tr v-if="specialtyExam" ref="compare14">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current14 == 1}">{{ item.specialtyExam }}</div>
            </td>
          </tr>
          <tr v-if="others" ref="compare15">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current15 == 1}">{{ item.others }}</div>
            </td>
          </tr>
          <tr v-if="remarks" ref="compare16">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current16 == 1}">{{ item.remarks }}</div>
            </td>
          </tr>
          <tr v-if="positionType" ref="compare17">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current17 == 1}">{{ item.positionType }}</div>
            </td>
          </tr>
          <tr v-if="extSignUpCount" ref="compare18">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current18 == 1}">{{ item.extSignUpCount }}</div>
            </td>
          </tr>
          <tr v-if="competition" ref="compare19">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current22 == 1}">{{ item.competition }}</div>
            </td>
          </tr>
          <tr v-if="extMinPaperScore" ref="compare20">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current19 == 1}">{{ item.extMinPaperScore }}</div>
            </td>
          </tr>
          <tr v-if="extMaxPaperScore" ref="compare21">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current20 == 1}">{{ item.extMaxPaperScore }}</div>
            </td>
          </tr>
          <tr v-if="extInterviewCount" ref="compare22">
            <td v-for="item in tableData" :key="item.id" align="center">
              <div class="compare_sznr" :class="{ active:current21 == 1}">{{ item.extInterviewCount }}
                <van-button size="mini" type="info"  @click="handleScore(item.positionCode)">查看面试名单</van-button>
                </div>
            </td>
          </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <p style="font-weight: 400;color: #FF3229;font-size: 0.75rem; margin: 10px 10px">华智公考提示广大考生，请报考前仔细阅读对应职位招录要求或联系招录单位确认，本职位检索系统提供内容仅供参考！</p>
  </div>
</template>

<script>
import '@/utils/table.css'
import $ from 'jquery'
import IScroll from 'iscroll/build/iscroll-probe'
import { api_position } from '@/common/Request.js'
import { divide } from '@/utils/number'
export default {
  name: 'App',
  data() {
    return {
      list: [],
      tableData: [],
      checked:false,
      checked1:false,
       extAreaShow: true,
      organsShow: true,
      unitsShow: true,
      positionNameShow: true,
      positionDescShow: true,
      positionCodeShow: true,
      underGraduateShow: true,
      numbers: true,
      target: true,
      graduate: true,
      education: true,
      degree: true,
      political: true,
      specialtyExam: true,
      others: true,
      remarks: true,
      positionType: true,
      extSignUpCount: true,
      extMinPaperScore: true,
      extMaxPaperScore: true,
      extInterviewCount: true,
      competition: true,
      current1: 0,
      current2: 0,
      current3: 0,
      current4: 0,
      current5: 0,
      current6: 0,
      current7: 0,
      current8: 0,
      current9: 0,
      current10: 0,
      current11: 0,
      current12: 0,
      current13: 0,
      current14: 0,
      current15: 0,
      current16: 0,
      current17: 0,
      current18: 0,
      current19: 0,
      current20: 0,
      current21: 0,
      current22: 0,
      height1: 0,
      height2: 0,
      height3: 0,
      height4: 0,
      height5: 0,
      height6: 0,
      height7: 0,
      height8: 0,
      height9: 0,
      height10: 0,
      height11: 0,
      height12: 0,
      height13: 0,
      height14: 0,
      height15: 0,
      height16: 0,
      height17: 0,
      height18: 0,
      height19: 0,
      height20: 0,
      height21: 0,
      height22: 0,
      height23: 0,
      zyear: '',
      actions: [{ text: "2021",value:"2021" },{ text: "2024",value: "2024" },{ text: "2023",value: '2023' },{ text: "2022",value:"2022" } ],
    }
  },
  created() {
    this.detailsList()
  },
    mounted () {
    this.tableScroll()
  },
  methods: {
     detailsList() {
      api_position.positionDetails({ code: this.$route.query.code,zyear: this.zyear }).then(res => {
        this.tableData = res.data
        this.tableData.forEach(item => {
          item.positionNameCode = item.positionName
          // 竞争比
          item.competition = divide(item.extSignUpCount, item.extInterviewCount)
        })
         this.$nextTick(()=>{
         this.getHeight()
      })
      })
    },
    getHeight() {
      this.height1 = this.$refs.compare1.offsetHeight + 'px'
      this.height2 = this.$refs.compare2.offsetHeight + 'px'
      this.height3 = this.$refs.compare3.offsetHeight + 'px'
      this.height4 = this.$refs.compare4.offsetHeight + 'px'
      this.height5 = this.$refs.compare5.offsetHeight + 'px'
      this.height6 = this.$refs.compare6.offsetHeight + 'px'
      this.height7 = this.$refs.compare7.offsetHeight + 'px'
      this.height8 = this.$refs.compare8.offsetHeight + 'px'
      this.height9 = this.$refs.compare9.offsetHeight + 'px'
      this.height10 = this.$refs.compare10.offsetHeight + 'px'
      this.height11 = this.$refs.compare11.offsetHeight + 'px'
      this.height12 = this.$refs.compare12.offsetHeight + 'px'
      this.height13 = this.$refs.compare13.offsetHeight + 'px'
      this.height14 = this.$refs.compare14.offsetHeight + 'px'
      this.height15 = this.$refs.compare15.offsetHeight + 'px'
      this.height16 = this.$refs.compare16.offsetHeight + 'px'
      this.height17 = this.$refs.compare17.offsetHeight + 'px'
      this.height18 = this.$refs.compare18.offsetHeight + 'px'
      this.height19 = this.$refs.compare19.offsetHeight + 'px'
      this.height20 = this.$refs.compare20.offsetHeight + 'px'
      this.height21 = this.$refs.compare21.offsetHeight + 'px'
      this.height22 = this.$refs.compare22.offsetHeight + 'px'
      this.height23 = this.$refs.title.offsetHeight + 'px'
    },
     handleHighLigth() {
      if (!this.checked) {
        if (!this.tableData.every(item => item.extArea === this.tableData[0].extArea)) {
          this.current1 = 1
        }
        if (!this.tableData.every(item => item.organs === this.tableData[0].organs)) {
          this.current2 = 1
        }
        if (!this.tableData.every(item => item.units === this.tableData[0].units)) {
          this.current3 = 1
        }
        if (!this.tableData.every(item => item.positionName === this.tableData[0].positionName)) {
          this.current4 = 1
        }
        if (!this.tableData.every(item => item.positionCode === this.tableData[0].positionCode)) {
          this.current5 = 1
        }
        if (!this.tableData.every(item => item.positionDesc === this.tableData[0].positionDesc)) {
          this.current6 = 1
        }
        if (!this.tableData.every(item => item.underGraduate === this.tableData[0].underGraduate)) {
          this.current7 = 1
        }
        if (!this.tableData.every(item => item.numbers === this.tableData[0].numbers)) {
          this.current8 = 1
        }
        if (!this.tableData.every(item => item.target === this.tableData[0].target)) {
          this.current9 = 1
        }
        if (!this.tableData.every(item => item.graduate === this.tableData[0].graduate)) {
          this.current10 = 1
        }
        if (!this.tableData.every(item => item.education === this.tableData[0].education)) {
          this.current11 = 1
        }
        if (!this.tableData.every(item => item.degree === this.tableData[0].degree)) {
          this.current12 = 1
        }
        if (!this.tableData.every(item => item.political === this.tableData[0].political)) {
          this.current13 = 1
        }
        if (!this.tableData.every(item => item.specialtyExam === this.tableData[0].specialtyExam)) {
          this.current14 = 1
        }
        if (!this.tableData.every(item => item.others === this.tableData[0].others)) {
          this.current15 = 1
        }
        if (!this.tableData.every(item => item.remarks === this.tableData[0].remarks)) {
          this.current16 = 1
        }
        if (!this.tableData.every(item => item.positionType === this.tableData[0].positionType)) {
          this.current17 = 1
        }
        if (!this.tableData.every(item => item.extSignUpCount === this.tableData[0].extSignUpCount)) {
          this.current18 = 1
        }
        if (!this.tableData.every(item => item.extMinPaperScore === this.tableData[0].extMinPaperScore)) {
          this.current19 = 1
        }
        if (!this.tableData.every(item => item.extMaxPaperScore === this.tableData[0].extMaxPaperScore)) {
          this.current20 = 1
        }
        if (!this.tableData.every(item => item.extInterviewCount === this.tableData[0].extInterviewCount)) {
          this.current21 = 1
        }
        if (!this.tableData.every(item => item.competition === this.tableData[0].competition)) {
          this.competition = 1
        }
      }
      if (this.checked) {
        this.current1 = 0
        this.current2 = 0
        this.current3 = 0
        this.current4 = 0
        this.current5 = 0
        this.current6 = 0
        this.current7 = 0
        this.current8 = 0
        this.current9 = 0
        this.current10 = 0
        this.current11 = 0
        this.current12 = 0
        this.current13 = 0
        this.current14 = 0
        this.current15 = 0
        this.current16 = 0
        this.current17 = 0
        this.current18 = 0
        this.current19 = 0
        this.current20 = 0
        this.current21 = 0
        this.current22 = 0
      }
    },
    handleSamehide() {
      if (!this.checked1) {
        if (this.tableData.every(item => item.extArea === this.tableData[0].extArea)) {
          this.extAreaShow = false
        }
        if (this.tableData.every(item => item.organs === this.tableData[0].organs)) {
          this.organsShow = false
        }
        if (this.tableData.every(item => item.units === this.tableData[0].units)) {
          this.unitsShow = false
        }
        if (this.tableData.every(item => item.positionName === this.tableData[0].positionName)) {
          this.positionNameShow = false
        }
        if (this.tableData.every(item => item.positionDesc === this.tableData[0].positionDesc)) {
          this.positionDescShow = false
        }
        if (this.tableData.every(item => item.positionCode === this.tableData[0].positionCode)) {
          this.positionCodeShow = false
        }
        if (this.tableData.every(item => item.underGraduate === this.tableData[0].underGraduate)) {
          this.underGraduateShow = false
        }
        if (this.tableData.every(item => item.numbers === this.tableData[0].numbers)) {
          this.numbers = false
        }
        if (this.tableData.every(item => item.target === this.tableData[0].target)) {
          this.target = false
        }
        if (this.tableData.every(item => item.graduate === this.tableData[0].graduate)) {
          this.graduate = false
        }
        if (this.tableData.every(item => item.education === this.tableData[0].education)) {
          this.education = false
        }
        if (this.tableData.every(item => item.degree === this.tableData[0].degree)) {
          this.degree = false
        }
        if (this.tableData.every(item => item.political === this.tableData[0].political)) {
          this.political = false
        }
        if (this.tableData.every(item => item.specialtyExam === this.tableData[0].specialtyExam)) {
          this.specialtyExam = false
        }
        if (this.tableData.every(item => item.others === this.tableData[0].others)) {
          this.others = false
        }
        if (this.tableData.every(item => item.remarks === this.tableData[0].remarks)) {
          this.remarks = false
        }
        if (this.tableData.every(item => item.positionType === this.tableData[0].positionType)) {
          this.positionType = false
        }
        if (this.tableData.every(item => item.extSignUpCount === this.tableData[0].extSignUpCount)) {
          this.extSignUpCount = false
        }
        if (this.tableData.every(item => item.extMinPaperScore === this.tableData[0].extMinPaperScore)) {
          this.extMinPaperScore = false
        }
        if (this.tableData.every(item => item.extMaxPaperScore === this.tableData[0].extMaxPaperScore)) {
          this.extMaxPaperScore = false
        }
        if (this.tableData.every(item => item.extInterviewCount === this.tableData[0].extInterviewCount)) {
          this.extInterviewCount = false
        }
        if (this.tableData.every(item => item.competition === this.tableData[0].competition)) {
          this.competition = false
        }
      }
      if (this.checked1) {
        this.extAreaShow = true
        this.organsShow = true
        this.unitsShow = true
        this.positionNameShow = true
        this.positionDescShow = true
        this.positionCodeShow = true
        this.underGraduateShow = true
        this.numbers = true
        this.target = true
        this.graduate = true
        this.education = true
        this.degree = true
        this.political = true
        this.specialtyExam = true
        this.others = true
        this.remarks = true
        this.positionType = true
        this.extSignUpCount = true
        this.extMinPaperScore = true
        this.extMaxPaperScore = true
        this.extInterviewCount = true
        this.competition = true
      }
    },
    handleYear() {
      this.detailsList()
    },
    handleScore(positionCode) {
       this.$router.push({ name: 'interviewlist',query: { positionCode: positionCode,zyear:this.zyear}})
    },
     handleDelete(items) {
      this.tableData = this.tableData.filter(item => item.id !== items.id)
    },
    tableScroll () {
      /* eslint-disable */
      let win = $('.data-table')
      var rightTableEl = $('.t_r_t table') // 右头
      var leftFreezeEl = $('.t_l_freeze')
      var leftTableEl = leftFreezeEl.find('table') // 左行
      var scrollAreaEl = $('.t_r_content') // 右行
      // 动态计算容器最大高度
      function adjustHeight () {
        var winHeight = win.height() - 40
        var tableHeight = winHeight
        leftFreezeEl.height(tableHeight)
        scrollAreaEl.height(tableHeight)
      }
      adjustHeight()
      win.resize(function () {
        adjustHeight()
      })
      var myScroll = new IScroll('.t_r_content', {
        scrollX: true,
        scrollY: true,
        // scrollbars: true,
        mouseWheel: true,
        bounce: true,
        probeType: 3
      })
      scrollAreaEl.on('touchmove mousewheel', function (e) {
        // 右行
        e.preventDefault()
      })
      myScroll.on('scroll', updatePosition)
      myScroll.on('scrollEnd', updatePosition)
      function updatePosition () {
        myScroll.refresh()
        var y = this.y
        var x = this.x
        leftTableEl.css(
          'transform',
          'translate(0px, ' + y + 'px) translateZ(0px)'
        ) // 左行
        rightTableEl.css(
          'transform',
          'translate(' + x + 'px, 0px) translateZ(0px)'
        ) // 右头
        myScroll.refresh()
      }
    },
  }

}
</script>

<style lang="scss" scoped>
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 31.25rem /* 1000/32 */;
}
 .active {
      color: #FF3229;
    }
.header-top {
      background-color: #fff;
      //width: 23.4375rem /* 750/32 */;
      height: 3.15625rem /* 101/32 */;
      box-sizing: border-box;
      padding: 1.0625rem /* 34/32 */ 1.21875rem /* 39/32 */;
      .logo {
        float: left;
        img {
          width: 7.375rem /* 236/32 */;
          height: 1.4375rem /* 46/32 */;
        }
      }
      .title {
        margin-left: 1.3125rem /* 42/32 */;
        float: left;
        span {
          color: #333;
          font-size: .9375rem /* 30/32 */;
          font-family: PingFang SC;
          font-weight: bold;
          // height: 3.142857rem;
        }
      }
      .icon {
       width: 6.25rem /* 200/32 */;
      height: 1.5625rem /* 50/32 */;
        float: right;
       ::v-deep .van-dropdown-menu__bar {
         height: 1.25rem /* 40/32 */;
         box-shadow: 0 0 ;
       }
      }
    }
</style>
